import Http from "../../services/HTTP";
import {getVendorType} from "../../services/auth";
const querystring = require('querystring');
const GET_VENDOR_TRANSACTIONS = 'GET_VENDOR_TRANSACTIONS';
const GET_VENDOR_TRANSACTIONS_TOTAL = 'GET_VENDOR_TRANSACTIONS_TOTAL';
const GET_FILTER_TRANSACTONS_BY_DATE = "GET_FILTER_TRANSACTONS_BY_DATE";
// allTransactions to admin panel starts here
function allTransactionsWaiting() {
    return {
        type : GET_VENDOR_TRANSACTIONS,
        all_transactions_waiting : true,
        all_transactions_response : {},
        all_transactions_error : {}
    }
}

function allTransactionsSuccess(response) {
    return {
        type: GET_VENDOR_TRANSACTIONS,
        all_transactions_waiting : false,
        all_transactions_response : response,
        all_transactions_error : {}
    }
}

function allTransactionsError(error) {
    return {
        type : GET_VENDOR_TRANSACTIONS,
        all_transactions_waiting : false,
        all_transactions_response : {},
        all_transactions_error : error
    }
}

function allTransactionsWaitingTotal() {
    return {
        type : GET_VENDOR_TRANSACTIONS_TOTAL,
        all_transactions_waiting_total : true,
        all_transactions_response_total : {},
        all_transactions_error_total : {}
    }
}

function allTransactionsSuccessTotal(response) {
    return {
        type: GET_VENDOR_TRANSACTIONS_TOTAL,
        all_transactions_waiting_total : false,
        all_transactions_response_total : response,
        all_transactions_error_total : {}
    }
}

function allTransactionsErrorTotal(error) {
    return {
        type : GET_VENDOR_TRANSACTIONS_TOTAL,
        all_transactions_waiting_total : false,
        all_transactions_response_total : {},
        all_transactions_error_total : error
    }
}

function getAllTransactions(data) {
    let queryString = querystring.stringify(data);
    let vendor_type = getVendorType();
    return (dispatch) => {
        dispatch(allTransactionsWaiting());
        const get = Http.GET((vendor_type === 'DRUG' ? 'pharmacy' : 'lab-test') + '/v1/transactions'+'?'+queryString,{});
        get.then((response) => {
            if (response !== undefined)
                dispatch(allTransactionsSuccess(response));
        }).catch((error) => {
            dispatch(allTransactionsError(error));
        });
    }
}

function getAllTransactionsTotal(data) {
    let queryString = querystring.stringify(data);
    let vendor_type = getVendorType();
    return (dispatch) => {
        dispatch(allTransactionsWaitingTotal());
        const get = Http.GET((vendor_type === 'DRUG' ? 'pharmacy' : 'lab-test') + '/v1/transactions'+'?'+queryString,{});
        get.then((response) => {
            if (response !== undefined)
                dispatch(allTransactionsSuccessTotal(response));
        }).catch((error) => {
            dispatch(allTransactionsErrorTotal(error));
        });
    }
}

function filterTransactionsSuccess(response) {
    return {
      type: GET_FILTER_TRANSACTONS_BY_DATE,
      filter_transactions_waiting : false,
      filter_transactions_response : response,
      filter_transactions_error : {}
    }
  }
  
  function filterTransactionsError(error) {
    return {
      type : GET_FILTER_TRANSACTONS_BY_DATE,
      filter_transactions_waiting : false,
      filter_transactions_response : {},
      filter_transactions_error : error
    }
  }

  function filterTransactionsWaiting() {
    return {
        type : GET_FILTER_TRANSACTONS_BY_DATE,
        filter_transactions_waiting : true,
        filter_transactions_response : {},
        filter_transactions_error : {}
    }
}
  
  function filterOrdersByDate(data) {
    let queryString = querystring.stringify(data);
    let vendor_type = JSON.parse(localStorage.getItem('user'))['vendor_type'];
    vendor_type = vendor_type ?? 'LAB';
    let source = vendor_type === 'DRUG' ? 'pharmacy' : 'lab-test';
    return (dispatch) => {
      dispatch(filterTransactionsWaiting());
      const get = Http.GET((vendor_type === 'DRUG' ? 'pharmacy' : 'lab-test') + '/v1/transactions/export'+'?'+queryString,{});
      get.then((response) => {
        if (response !== undefined)
          dispatch(filterTransactionsSuccess(response));
      }).catch((error) => {
        dispatch(filterTransactionsError(error));
      });
    }
  }

export {
    GET_VENDOR_TRANSACTIONS,
    GET_VENDOR_TRANSACTIONS_TOTAL,
    getAllTransactions,
    getAllTransactionsTotal,
    GET_FILTER_TRANSACTONS_BY_DATE,
    filterOrdersByDate
}